<template>
    <div>
        <h3 id="top-feuillet">{{$t("Calculette.etape1.titre")}}</h3>
       <!-- Formulaire calculette-->
        <form role="form" @submit="onSubmit">
            <div class="row clearfix">
                <div class="col-md-6 column">
                    <!-- Année fiscale-->
                    <div class="form-group required" :class="{'has-error': errors.has('periodeFiscale')}">
                        <label for="selPeriodeFiscale" class="form-label required">{{ $t("Calculette.champs.periodeFiscale") }}</label>
                        <select class="form-control" v-model="periodeFiscale" @change="onChangePeriodeFiscale($event)"
                                v-validate="'required'" name="periodeFiscale" id="selPeriodeFiscale" title="">
                            <option v-for="(periodefiscale, index) in listePeriodesFiscales" v-bind:key="index" :value="periodefiscale">
                                {{ periodefiscale }}
                            </option>
                        </select>
                        <span v-if="submitted && errors.has('periodeFiscale')" class="text-danger">{{ errors.first('periodeFiscale') }}</span>
                    </div>
                    <!-- Baremes-->
                    <div class="form-group required" :class="{'has-error': errors.has('bareme')}">
                        <label for="selBareme" class="form-label">{{ $t("Calculette.champs.bareme") }}</label>
                        <p class="help-block" v-html="$t('Calculette.etape1.infoBaremes')"> </p>
                        <select @change="onChangeBareme($event)" class="form-control" v-model="bareme"
                                v-validate="'required'" :disabled="periodeFiscale === ''" name="bareme" id="selBareme">
                            <option v-for="bareme in listeBaremes" v-bind:key="bareme.id" :value="bareme.code">
                                {{ bareme.code }}
                            </option>
                        </select>
                        <span v-if="submitted && errors.has('bareme')" class="text-danger">{{ errors.first('bareme') }}</span>
                    </div>
                    <!-- Revenu contribuable-->
                    <section-revenu-mask v-model="revenuContribuable" :nomChamp="'revenuContribuable'"
                                         :submitted="submitted" withValidation='required'
                                         :lbl-revenu='$t("Calculette.champs.revenuContribuable")' monnaie="CHF"
                                         tooltip-titre='Calculette.tooltip.titre.revenuContribuable'
                                         tooltip-contenu='Calculette.tooltip.contenu.revenuContribuable'>
                    </section-revenu-mask>
                    <!-- Revenu Conjoint-->
                    <section-revenu-mask v-if="isRevenuConjoint" v-model="revenuConjoint" :nomChamp="'revenuConjoint'"
                                         withValidation='required' :submitted="submitted"
                                         :lbl-revenu='$t("Calculette.champs.revenuConjoint")' monnaie="CHF"
                                         :options-contenu="{tauxChange: tauxChange}"
                                         tooltip-titre='Calculette.tooltip.titre.revenuConjoint'
                                         tooltip-contenu='Calculette.tooltip.contenu.revenuConjoint'>
                    </section-revenu-mask>
                </div>
            </div>
            <div class="row clearfix">
                <div class="col-md-10 column">
                    <!--Pour le taux-->
                    <div class="form-group" v-if="isRevenuConjoint">
                        <label for="chkIsPourLeTaux" class="form-label">{{ $t("Calculette.champs.taux") }}</label>
                        <div class="input-group">
                            <input type="checkbox" class="checkbox" v-model="isTaux" id="chkIsPourLeTaux" aria-labelledby="spPourLeTaux">
                        </div>
                        <div class="form-group">
                            <p> <span id="spPourLeTaux" v-html='$t("Calculette.pourLeTaux")'></span></p>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <button type="button" name="next" class="btn btn-primary submitandwait" @click="onSubmit">
            {{$t("Calculette.buttons.calculer")}}
        </button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import CalculetteDto from '@/models/CalculetteDto';
import ImpotSourceDto from '@/models/calculette/ImpotSourceDto';
import BaremeApi from '@/services/BaremeRestApi';
import ImpotSourceRestApi from '@/services/ImpotSourceRestApi';
import TitreRestApi from '@/services/TitreRestApi';
import ProgressBarUtils from '@/utils/ProgressBarUtils';
import SectionRevenuMask from '../commun/SectionRevenuMask.vue';

export default {
  name: 'calculette-etape-1',
  components: { SectionRevenuMask },
  mixins: [ProgressBarUtils],
  methods: {
    ...mapActions(['setUrlEnSavoirPlus']),
    async onSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.revenuContribuable = this.revenuContribuable.replace(/\D/g, '');
      this.revenuConjoint = this.revenuConjoint.replace(/\D/g, '');
      const isValide = await this.$validator.validate();
      if (isValide) {
        const impotSourceDto = this.buildImpotSourceDto();
        const reponseBackend = await new ImpotSourceRestApi().calculerImpot(impotSourceDto);
        // Mapping réponse back-end vers dto front-end
        const resultat = this.mapReponseBackEnd(reponseBackend);
        this.$router.push({ name: 'routeCalculetteEtape2', params: { resultat } });
      } else {
        // Scroll vers le prémier erreur du formulaire
        this.$el.querySelector(`[name=${this.$validator.errors.items[0].field}]`).closest('.form-group').scrollIntoView();
      }
    },
    buildImpotSourceDto() {
      const impotSourceDto = new ImpotSourceDto();
      impotSourceDto.annee = this.periodeFiscale;
      impotSourceDto.codeBareme = this.bareme;
      impotSourceDto.isPourLeTaux = this.isTaux;
      if (this.bareme.startsWith('Cr')) {
        impotSourceDto.revenuContribuable = Number(this.revenuContribuable);
        impotSourceDto.revenuConjoint = Number(this.revenuConjoint);
        if (this.isTaux) {
          impotSourceDto.revenuGlobal = Number(this.revenuContribuable);
        } else {
          impotSourceDto.revenuGlobal = Number(this.revenuContribuable) + Number(this.revenuConjoint);
        }
      } else {
        impotSourceDto.revenuContribuable = this.revenuContribuable;
        impotSourceDto.revenuGlobal = this.revenuContribuable;
      }
      return impotSourceDto;
    },
    mapReponseBackEnd(reponseBackend) {
      const resultat = new CalculetteDto();
      resultat.annee = reponseBackend.annee;
      resultat.bareme = reponseBackend.codeBareme;
      resultat.codeBaremePrelevement = `C${reponseBackend.codeBareme.substr(2)}`;
      resultat.isBaremeRectif = this.bareme.startsWith('Cr');
      resultat.isBaremeAjuste = false;
      resultat.revenuContribuable = this.revenuContribuable;
      resultat.revenuConjoint = this.revenuConjoint;
      resultat.revenuImpose = this.revenuContribuable;
      // resultat.taux = (reponseBackend.tauxContribuable * 100).toFixed(2);
      resultat.taux = 0;
      if (reponseBackend.tauxContribuable) {
        resultat.taux = (reponseBackend.tauxContribuable * 100).toFixed(2);
      }
      resultat.montantImpot = reponseBackend.impotDuGlobal;
      resultat.isTaux = this.isTaux;
      resultat.revenuUtilisePourLeTaux = reponseBackend.revenuContribuable;

      if (this.bareme.startsWith('Cr')) {
        resultat.tauxContribuable = 0;
        if (reponseBackend.tauxContribuable) {
          resultat.tauxContribuable = (reponseBackend.tauxContribuable * 100).toFixed(2);
        }
        // resultat.tauxContribuable = (reponseBackend.tauxContribuable * 100).toFixed(2);
        resultat.montantImpotContribuable = reponseBackend.impotDuContribuable;

        resultat.taux = 0;
        if (reponseBackend.tauxGlobal) {
          resultat.taux = (reponseBackend.tauxGlobal * 100).toFixed(2);
        }
        // resultat.taux = (reponseBackend.tauxGlobal * 100).toFixed(2);
        resultat.revenuUtilisePourLeTaux = reponseBackend.revenuGlobal;
        resultat.tauxConjoint = 0;
        if (reponseBackend.tauxConjoint) {
          resultat.tauxConjoint = (reponseBackend.tauxConjoint * 100).toFixed(2);
        }
        resultat.montantImpotConjoint = reponseBackend.impotDuConjoint;
        if (Number(reponseBackend.impotRemboursement) > 0) {
          resultat.solde = Number(reponseBackend.impotRemboursement) * -1;
        } else {
          resultat.solde = Math.abs(reponseBackend.impotRemboursement);
        }

        if (this.isTaux) {
          resultat.montantImpotCouple = reponseBackend.impotDuContribuable;
          // Workaround temporaire pour que ce soit ISO fonctionnel
          resultat.montantImpot = Number(this.revenuContribuable * reponseBackend.tauxGlobal).toFixed(2);
          resultat.solde = (resultat.montantImpotContribuable == null ? 0 : resultat.montantImpotContribuable) - resultat.montantImpot;
        } else {
          let impotDuContribuable = 0;
          let impotDuConjoint = 0;
          if (reponseBackend.impotDuContribuable) {
            impotDuContribuable = Number(reponseBackend.impotDuContribuable);
          } if (reponseBackend.impotDuConjoint) {
            impotDuConjoint = Number(reponseBackend.impotDuConjoint);
          }
          resultat.montantImpotCouple = impotDuContribuable + impotDuConjoint;
          resultat.revenuImpose = Number(this.revenuContribuable) + Number(this.revenuConjoint);
        }
      }
      return resultat;
    },
    /**
     * Méthode qui gére l'affichage de la partie conjoint lors d'un changement de barème
     */
    onChangeBareme(event) {
      if (event.target.value.startsWith('Cr')) {
        this.isRevenuConjoint = true;
      } else {
        this.isRevenuConjoint = false;
      }
    },
    /**
     * Méthode qui charge la liste des barèmes lors d'un changement de période fiscale
     */
    onChangePeriodeFiscale(event) {
      this.getListeBaremeParAnnee(event.target.value);
    },
    /**
      * Charger la liste des 3 années pour répondre au besoin des contribuables changeant de situation sur Décembre
      * @returns {Promise<void>}
      */
    async getListePeriodeFiscale() {
      try {
        // this.listePeriodesFiscales = await BaremeApi.getListePeriodeFiscale('B0', 2); // eslint-disable-next-line
        const coApi = new BaremeApi();
        this.listePeriodesFiscales = await coApi.getListePeriodeFiscale(3); // eslint-disable-next-line
        if (this.listePeriodesFiscales[0]) {
          this.listeBaremes = await coApi.getBarameForYear(this.listePeriodesFiscales[0]);
        } else {
          this.$log.error('Error liste periode fiscale invalide !');
        }
      } catch (exError) {
        this.$log.error('Error liste periode fiscale');
      }
    },
    /**
      *
      * @param annee L'année pour laquelle on veut charger la liste des barèmes
      * @returns {Promise<void>}
      */
    async getListeBaremeParAnnee(iniAnnee) {
      try {
        this.listeBaremes = await new BaremeApi().getBarameForYear(iniAnnee);
        this.tauxChange = await new TitreRestApi().getTauxChange(this.periodeFiscale, 'EUR');
      } catch (exError) {
        this.$log.error(`Error liste baremes pour l'année: ${iniAnnee}`);
      }
    },
  },
  data() {
    return {
      periodeFiscale: '',
      bareme: '',
      revenuContribuable: '',
      revenuConjoint: '',
      isTaux: false,
      isRevenuConjoint: false,
      listePeriodesFiscales: [],
      listeBaremes: [],
      submitted: false,
      resultat: undefined,
      tauxChange: '',
    };
  },
  mounted() {
    // Charger la liste des années fiscales (2 ans)
    this.getListePeriodeFiscale();
    this.setUrlEnSavoirPlus('https://www.ge.ch/impot-source/baremes-perception-calculette-impot-source');
    this.initProgressBar(2, [this.$t('Calculette.progressBar.etape1'), this.$t('Calculette.progressBar.etape2')], 1, this.$t('Calculette.titre'));
  },
};
</script>

<style>

</style>
